<template>
  <div class="bread_crumb">
    <div class="bread_crumb_inner">
      <a href="" class="home">홈</a>
      <a href="">마이페이지</a>
      <a>비밀번호변경</a>
    </div>
  </div>
  <main id="main">
    <div class="contents">
      <div class="mypage_wrap">
        <MyHeader />
        <div class="mypage_body">
          <MySideBar />
          <ChangePwdForm />
        </div>
      </div>
    </div>
  </main>
  <MainSideBar />
</template>
<script>
import MainSideBar from "../../layout/navigation/MainSideBar.vue";
import MyHeader from "../layout/MyHeader.vue";
import MySideBar from "../layout/MySideBar.vue";
import ChangePwdForm from "@/components/mypage/privacyManagement/ChangePwdForm.vue";

export default {
  components: {
    MainSideBar,
    MyHeader,
    MySideBar,
    ChangePwdForm,
  },
};
</script>
<style lang=""></style>
